import { registerDebugNamespace } from '@/lib/debug/registerDebugNamespace';
import {
  USER_PREVIEW_CACHE_TTL_MS as STORE_CACHE_TTL_MS,
  userPreviewStore,
} from '@/store/user-preview/user-preview-store';

import { createUserPreviewCacheService } from './user-preview-cache.service';
import { createUserPreviewCacheStorage } from './user-preview-cache.storage';
import { DEBUG_NAMESPACE } from './user-preview-cache.types';

export const USER_PREVIEW_CACHE_TTL_MS = STORE_CACHE_TTL_MS;

export type UserPreviewCacheRuntime = Awaited<ReturnType<typeof createUserPreviewCacheRuntime>>;

export async function createUserPreviewCacheRuntime(options: { debugEnabled?: boolean; cacheTtlMs?: number } = {}) {
  const cacheTtlMs = options.cacheTtlMs ?? USER_PREVIEW_CACHE_TTL_MS;
  const storage = await createUserPreviewCacheStorage(cacheTtlMs);

  const service = createUserPreviewCacheService({
    ...storage,
    cacheTtlMs,
    debugNamespace: DEBUG_NAMESPACE,
    store: userPreviewStore,
    debugEnabled: options.debugEnabled ?? true,
  });

  service.bootstrapStoreFromCollection();
  service.publishDebugSnapshot();

  registerDebugNamespace(DEBUG_NAMESPACE, {});

  return {
    ...service,
    storage,
    cacheTtlMs,
  } as const;
}
